var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelephone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.281,
    height: 7.281,
    viewBox: "0 0 7.281 7.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M7.073,5.145,5.48,4.463a.341.341,0,0,0-.4.1l-.705.862A5.271,5.271,0,0,1,1.857,2.9L2.719,2.2a.34.34,0,0,0,.1-.4L2.134.207a.344.344,0,0,0-.391-.2L.264.35A.341.341,0,0,0,0,.683a6.6,6.6,0,0,0,6.6,6.6.341.341,0,0,0,.333-.264l.341-1.479a.345.345,0,0,0-.2-.392Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0.64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelephone);
export default __webpack_public_path__ + "static/media/icon-telephone.29ccb523548ddc57e0e6e20a5b3cf8d4.svg";
export { ForwardRef as ReactComponent };